import breakTo from '../../styles/tools/breakTo'

export default () => ({
  wrapper: {
    width: '90%',
    maxWidth: '43rem',
    margin: '0 auto',

    flex: '1 0 auto',
    alignItems: 'flex-start',

    [breakTo('small')]: {
      minWidth: '43rem'
    }
  },
  wrapperDigiMaxWidth:{
    maxWidth:'49rem!important'
  }

})



// WEBPACK FOOTER //
// ./components/wrapper/styles.js